export default "__VITE_ASSET__CWMU1ggr__"